import {
  Form,
  Icon,
  ICONS,
  PLATFORM_THEME_COLORS,
  Typography,
  UploadInput,
} from '@thinknet-gmbh/platform-common-ui';
import { Tooltip } from 'antd';

import { UploadFormItemWrapper, LabelWrapper } from './vacancies-form.styles';

const UploadFormItem = ({
  t,
  headerImage,
}: {
  t: Function;
  headerImage?: { location: string; filename: string; key: string };
}) => (
  <UploadFormItemWrapper>
    <Form.Item
      name="uploadedFile"
      valuePropName="file"
      rules={[
        {
          validator(_, value) {
            if (!value || value.file.size / 1024 / 1024 < 2) {
              return Promise.resolve();
            }
            return Promise.reject();
          },
          message: t('vacancies:validation.headerImageSizeError'),
        },
      ]}
      label={
        <LabelWrapper>
          <Typography>{t('vacancies:labels.uploadHeaderImage')}</Typography>
          <Tooltip
            color={PLATFORM_THEME_COLORS.primary.black}
            placement="top"
            arrowPointAtCenter
            overlayInnerStyle={{ minWidth: '310px' }}
            title={
              <Typography fontColor={PLATFORM_THEME_COLORS.primary.white}>
                {t('vacancies:labels.uploadHeaderTooltip')}
              </Typography>
            }
          >
            <div>
              <Icon
                icon={ICONS.infoCircleRegular}
                size={16}
                color={PLATFORM_THEME_COLORS.grayVariations.dark}
                rightMargin={false}
              />
            </div>
          </Tooltip>
        </LabelWrapper>
      }
    >
      <UploadInput
        showUploadList
        beforeUpload={() => false}
        variant="button"
        btnText={t('settings:documents.buttons.uploadFile')}
        accept=".jpeg, .jpg, .png"
        maxCount={1}
        defaultFileList={
          headerImage
            ? [
                {
                  uid: headerImage.key,
                  name: headerImage.filename,
                  url: headerImage.location,
                },
              ]
            : undefined
        }
      />
    </Form.Item>
  </UploadFormItemWrapper>
);

export default UploadFormItem;
